import Routes from 'routes';
import ThemeCustomization from 'themes';
import Locales from 'components/Locales';
import ScrollTop from 'components/ScrollTop';
import Snackbar from 'components/@extended/Snackbar';
import Notistack from 'components/third-party/Notistack';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';

import { JWTProvider as AuthProvider } from 'contexts/JWTContext';

const App = () => (
    <ThemeCustomization>
        <Locales>
            <ScrollTop>
                <AuthProvider>
                    <Notistack>
                        <ToastContainer />
                        <Routes />
                        <Snackbar />
                    </Notistack>
                </AuthProvider>
            </ScrollTop>
        </Locales>
    </ThemeCustomization>
);

export default App;
